export const SNOWPACK_PUBLIC_COMMIT_HASH = "f6287c732560f32036138d4e3fbb3b308843fb3a";
export const SNOWPACK_PUBLIC_GIT_BRANCH = "witful-style-rework";
export const SNOWPACK_PUBLIC_APP_VERSION = "";
export const MODE = "sandbox";
export const NODE_ENV = "sandbox";
export const SSR = false;